import styled from 'styled-components';
import { Flex } from '@amzn/storm-ui';

export const DataTableActionsFlex = styled(Flex)`
  justify-content: center;
  gap: 2.75rem;
`;

export const EditArtEventTableWrapper = styled.div`
  td:first-child {
    width: 21.875rem;
  }
`;
